import {UIModuleV2} from '@gongxigames/framework/slotV2/baseClasses/uiModuleV2/UiModuleV2';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {Container} from 'pixi.js';
import {uiMenuStore} from '@gongxigames/framework/slotV2/ui/services/UIMenu/uiMenuStore';
import {CoreDI, Device, inject, System} from '@gongxigames/framework/core';
import {$UIMenuBar, UIMenuBarConfig} from '@gongxigames/framework/slotV2/ui/ui-koala/modules/UIMenu/components/UIMenuBar';
import {SlotSettings} from '@gongxigames/framework/slot';

export class UIMenuModule extends UIModuleV2 {
    static NAME = 'UIMenuModule';

    @inject(CoreDI.System)
    private readonly _system!: System;

    // TODO convert to signals/move to store
    @inject(CoreDI.Settings)
    protected settings!: SlotSettings;

    @inject(CoreDI.Device)
    private _device!: Device;

    public static layer = LAYERS.KEYPAD;
    public container = new Container();

    private readonly config: UIMenuBarConfig = {
        home: {},
        fullscreen: {},
        info: {} ,
        game_rules: {},
        history: {},
        cashier: {},
        support: {},
        logout: {},
        close: {},
    };

    onInit(): void {
        const {
            homeUrl,
            historyUrl,
            supportUrl,
            logoutUrl,
            cashierUrl,
            hideHomeButton,
            hideHistoryButton,
            hideSupportButton,
            hideLogoutButton,
            hideCashierButton
        } = this.settings.getAllProperties();

        this.config.history.hide = !historyUrl || hideHistoryButton;
        this.config.support.hide = !supportUrl || hideSupportButton;
        this.config.logout.hide = !logoutUrl || hideLogoutButton;
        this.config.cashier.hide = !cashierUrl || hideCashierButton;
        this.config.home.hide = !homeUrl || hideHomeButton;
        this.config.fullscreen.hide = !this._device.fullscreen || !this._device.desktop;

        const uiDefault = $UIMenuBar({
            show: uiMenuStore.menuOpened,
            config: this.config
        }) as Container;

        this.container.addChild(uiDefault);
    }
}